import type {
  IProblemRecord,
  ISection,
  ISubnavItem,
  ITableBlock,
  ITableColumn,
  ITableUI,
} from "../../../shared/ui/data-table/model/data-table-contract";

export type {
  IProblemRecord,
  ISection,
  ISubnavItem,
  ITableBlock,
  ITableColumn,
  ITableUI,
};

export const getProblems = (store: {
  problems: { data: IProblemRecord | null };
}) => store.problems.data;
